<template>
  <div class="liu" v-wechat-title="'银行卡认证'">
    <camera ref="camera" @getImgInfo="getImgInfo" />
    <camera2 ref="camera2" @getImgInfo="getImgInfo" />
    <div class="color-f-bg">
      <div class="margin-l-15 padding-t-10 padding-b-10 border-b">
        <span>卡类型</span>
        <span>&nbsp;&nbsp;{{ bankNameAndBankType }}</span>
      </div>
      <div class="margin-l-15 padding-t-10 padding-b-10">
        <span style="padding-right: .3775rem">卡&nbsp;&nbsp;号</span>
        <span>&nbsp;&nbsp;{{ bankCardNo }}</span>
      </div>
    </div>
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
      <span>请验证持卡人本人人脸信息</span>
    </div>
    <div class="page-padding-l-r padding-t-10 padding-b-10 flex-s color-f-bg">
      <div style="width: 105px">人脸识别</div>
      <div @click="renLianInfo()">
        <img :src="renLian.base64" class="faceStyle" v-if="renLian.base64" />
        <svg-icon icon-class="camera_face" class-name="faceStyle" v-else></svg-icon>
      </div>
    </div>
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6" v-show="isFail">
      人脸识别对比失败，请
      <span class="theme-color" @click="resetCameraInfo('renLian'), resetCameraInfo('shouChi')">重新识别</span>或
      <span class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
    </div>
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
      <span>请验证持卡人本人手持身份证信息</span>
    </div>
    <div class="flex page-padding-l-r padding-t-10 padding-b-10 color-f-bg">
      <div style="width: 105px">
        <div class="margin-r-10">手持身份证正面照</div>
      </div>
      <div class="flex-1" @click="$refs.camera2.imgClick('shouChi')">
        <img :src="shouChi.base64 || require('@/assets/handheld_example@3x.png')" class="faceStyle" />
      </div>
    </div>
    <div>
      <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
        <span>避免证件与头部重叠，身份证证件内容要清晰可见，完全露出双手手臂</span>
        <span v-show="isFail">，如对比失败，请</span>
        <span v-show="isFail" class="theme-color" @click="resetCameraInfo('renLian'), resetCameraInfo('shouChi')">重新拍照</span>
        <span v-show="isFail">或</span>
        <span v-show="isFail" class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
      </div>
    </div>
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" @click="submitData">提交</mt-button>
    </div>
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
  </div>
</template>

<script>
/* global PUBLIC_TOKEN */
/* global PUBLIC_PRODUCT */
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import camera from '@/components/camera.vue';
import camera2 from '@/components/camera2.vue';
import Liveness from '@/components/Liveness';
import { formatDateId, upLoadImg } from '@/utils/utils.js';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { VerIdCardFace, AuditBankElementsStatus, YMTivingThing } from '@/api/weChat.js';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'LargeAuth',
  components: { camera, camera2, SvgIcon, Liveness },
  data() {
    return {
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 云码通人脸识别
      ymt: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      livingFacePopupVisible: false,
      // 认识是否失败
      isFail: false,
      // 是否需要活体认证
      faceDetectActivity: 0,
      // token
      token: PUBLIC_TOKEN,
      // 产品
      product: PUBLIC_PRODUCT,
    };
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus']),
    bankNameAndBankType() {
      const typeText = this.$route.query.cardtype === 1 ? '储蓄卡' : '信用卡';
      return `${this.$route.query.bankname} ${typeText}`;
    },
    bankCardNo() {
      const cardNo = this.$route.query.cardno;
      return cardNo.substr(0, 6) + '********' + cardNo.substr(-4); // 卡号
    },
  },
  watch: {
    livingFaceImgUrl(val) {
      this.renLian.base64 = val;
      this.renLian.fileUrl = val;
      this.renLian.webUrl = val;
    },
    livingFacePopupStatus(val) {
      this.livingFacePopupVisible = val;
    },
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 活体识别
    renLianInfo() {
      const discernFaceDate = sessionStorage.getItem('discernFaceDate') || 0;
      const mobile = this.$route.query.mobile || 99999999999;
      if (discernFaceDate - 0 !== formatDateId(new Date()) - 0) {
        sessionStorage.setItem('discernFaceDate', formatDateId(new Date()) - 0);
        sessionStorage.setItem(`${mobile}_facecount`, 0);
      }
      const faceCount = sessionStorage.getItem(`${mobile}_facecount`) || 0;
      const faceMaxCount = this.$route.query.facemax || 50;
      if (faceCount - 0 < faceMaxCount - 0) {
        if (faceMaxCount - 0 - (faceCount - 0) < 3) {
          // 请确定是否为身份证本人的人脸信息。
          CusAlert('您今天人脸识别次数还剩' + (faceMaxCount - 0 - (faceCount - 0)) + '次机会', () => this.jumpToLiveness());
        } else {
          this.jumpToLiveness();
        }
      } else {
        CusAlert('今天人脸识别次数已达上限，请明天再试');
      }
    },
    // 返回的图片信息
    getImgInfo(info) {
      this[info.type] = info;
      upLoadImg(
        info.blob,
        info.base64,
        info.type,
        yes => {
          if (yes.code === 0) {
            let reqUrl = null;
            switch (info.type) {
              case 'ymt':
                reqUrl = YMTivingThing;
                break;
              default:
                this[info.type].webUrl = yes.data;
                break;
            }
            if (info.type !== 'ymt') return;
            CusLoadingOpen('识别中...');
            reqUrl({ url: yes.data })
              .then(res => {
                CusLoadingClose();
                if (res.code === 0) {
                  this[info.type].webUrl = yes.data;
                  res.msg && CusAlert(res.msg);
                  switch (info.type) {
                    case 'ymt':
                      this.$nextTick(() => {
                        this.renLian.webUrl = yes.data;
                        this.renLian.fileUrl = yes.data;
                        this.renLian.base64 = yes.data;
                      });
                      break;
                  }
                } else {
                  CusAlert(res.msg, () => this.resetCameraInfo(info.type));
                }
              })
              .catch(() => {
                CusLoadingClose();
              });
          } else {
            this.resetCameraInfo(info.type);
          }
        },
        no => {
          this.resetCameraInfo(info.type);
        }
      );
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this.isFail = false;
    },
    // 跳人工审核
    jumpManualAudit() {
      CusAlert('人工审核将在1个工作日内处理完成，是否确定申请人工审核', () => {
        CusAlert('已为您提交人工审核，请继续完成后续认证流程，否则将无法通过人工审核', () => {
          AuditBankElementsStatus({
            cardNum: this.$route.query.cardno, // 卡号 ,
            faceUrl: this.renLian.webUrl, // 人像url ,
            holdidcard: this.shouChi.webUrl, // 手持照片url
          })
            .then(res => {
              CusLoadingClose();
              const msg = SucceedHandle(res.code, res.msg, () => {
                CusAlert(res.msg, () => {
                  wx.miniProgram.redirectTo({
                    url: `/pages/bankcardAuth/authIndex?pageTitle=银行卡认证`,
                  });
                });
              });
              msg && CusToast(msg);
            })
            .catch(err => {
              CusLoadingClose();
              const msg = NotSucceedHandle(err.message);
              msg && CusToast(msg);
            });
        });
      });
    },
    // 跳人脸识别
    jumpToLiveness() {
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          this.$refs.camera.imgClick('renLian');
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          this.$refs.camera2.imgClick('ymt');
          break;
      }
    },
    submitData() {
      if (!this.renLian.webUrl) {
        CusToast('请上传手持身份证照片');
        return;
      }
      CusLoadingOpen();
      VerIdCardFace({
        cardNum: this.$route.query.cardno,
        url: this.renLian.webUrl,
        isAddHoldIDCard: 1,
        holdIDCardUrl: this.shouChi.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          const msg = SucceedHandle(res.code, res.msg, () => {
            CusAlert(res.msg, () => {
              wx.miniProgram.switchTab({
                url: `/pages/home/home`,
              });
            });
          });
          if (res.code === 9069) {
            CusAlert(res.msg, () => (this.isFail = true));
          } else {
            msg && CusToast(msg);
          }
        })
        .catch(err => {
          CusLoadingClose();
          if ((err.code === 9990 && err.innerCode === 7775) || err.innerCode === 7776) {
            // 自动人工审核
            let msg = err.msg;
            if (err.innerCode === 7776) {
              msg = '今日人脸对比次数已达上限，已为您申请人工审核，预计将在1个工作日内完成审核';
            }
            CusAlert(msg, () => {
              wx.miniProgram.redirectTo({
                url: `/pages/bankcardAuth/authIndex?pageTitle=银行卡认证`,
              });
            });
          } else {
            CusAlert(err.msg, () => (this.isFail = true));
          }
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.faceDetectActivity = this.$route.query.faceDetectActivity - 0;
    });
  },
};
</script>
